import React from 'react';
import './MachineENG.css';
import backgroundImage from '../Assets/machineenginnering.PNG'; // Replace with your actual image path

const MachineENG = () => {
  return (
    <div
      className="machine-eng-container"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <img src={backgroundImage} alt="Machine Engineering background" style={{ display: 'none' }} />
      <div className="circle-content">
        <h1>Machine Engineering</h1>
        <p>
          Nous concevons, développons et optimisons des machines industrielles adaptées aux besoins spécifiques de nos clients. Notre expertise couvre l’ingénierie mécanique, l’automatisation, et l’intégration de systèmes pour offrir des solutions fiables, performantes et innovantes.
        </p>
      </div>
    </div>
  );
};

export default MachineENG;